import { render, staticRenderFns } from "./SelectEnviroment.vue?vue&type=template&id=b32d97ec"
import script from "./SelectEnviroment.vue?vue&type=script&lang=js"
export * from "./SelectEnviroment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports